module.exports = __webpack_public_path__ + "img/house-chimney-window.3e1aeb4d.svg";